import { sagas as dashboardSagas } from '../modules/Dashboard/store/sagas'
export const sagas = [...dashboardSagas]
